import { configureFetcher } from '@ordr-as/menu-builder-types/fetcher';
import { useRef } from 'react';
import config from '../config';
import { useAuth } from './AuthContext';

interface MenuBuilderFetcherProviderProps {
  children: React.ReactNode;
}

export const MenuBuilderFetcherProvider = ({ children }: MenuBuilderFetcherProviderProps) => {
  const { getAccessToken } = useAuth();
  const configuredRef = useRef(false);

  // Configure synchronously during render (before children render) to avoid race conditions
  if (!configuredRef.current) {
    configureFetcher({
      baseUrl: config.menuBuilderUrl,
      getHeaders: async () => {
        const accessToken = await getAccessToken();
        return {
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    configuredRef.current = true;
  }

  return children;
};
